import { Col, List, Row, Typography } from "antd";
import moment from "moment";
import { useIntl } from "react-intl";

import { TIMESTAMP_FORMAT } from "~app/constants";

type Props = {
  isLoading: boolean;
  taskHistoryRecords: any[];
};

export const TaskHistory = ({ isLoading, taskHistoryRecords }: Props) => {
  const { formatMessage } = useIntl();
  const data = taskHistoryRecords?.reverse() ?? [];

  return (
    <>
      <Row justify="center">
        <Col>
          <Typography.Title level={5}>{formatMessage({ id: "taskHistory.title" })}</Typography.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <List
            loading={isLoading}
            size="small"
            rowKey="added"
            dataSource={data}
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              backgroundColor: "#fff",
              borderRadius: "8px",
            }}
            renderItem={(item: any) => {
              const description = item?.text?.split("\n").map((line) => (
                <span key={`${item?.added ?? "unknown"}-${line}`}>
                  {line}
                  <br />
                </span>
              ));

              return (
                <List.Item>
                  <List.Item.Meta
                    title={`[${moment.utc(item?.added).local().format(TIMESTAMP_FORMAT)}] ${item?.userEmail}`}
                    description={description}
                  />
                </List.Item>
              );
            }}
          />
        </Col>
      </Row>
    </>
  );
};
